export class CollectionlocationsModel {
  Collectionlocations: string;
  constructor() {
    this.Collectionlocations = null;
  }
}
